var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_wrp page"},[_c('Hero'),_c('HomeContent'),_c('CTAView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }